export default theme => ({
    ciro: {
        display: 'flex',
        paddingBottom: '15px'
    },
    ciroLogo: {
        marginBottom: '10px'
    },
    footerDivider: {
        borderColor: '#2F2F2F',
        borderWidth: '0.5px',
        fontSize: '12px',
        fontWeight: '400',
        height: '10px',
        lineHeight: '20px',
        marginLeft: '7px',
        marginRight: '7px',
        marginTop: '7px'
    },
    footerRoot: {
        '@media (min-width: 431px)': {
            flex: '1',
        },
        justifyContent: 'flex-end',
        lineHeight: '20px'
    },
    link: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },
        alignSelf: 'start',
        color: '#60666D',
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '16px'
    },
    linkContainerMobile: {
        '@media (max-width: 1200px)': {
            justifyContent: 'flex-start',
            paddingBottom: '10px'
        },
        '@media screen and (min-width: 767px)': {
            display: 'none'
        },
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '-webkit-fill-available'
    },
    linkMain: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },
        alignSelf: 'start',
        color: '#2F2F2F',
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '20px'
    },
    linkMainFirst: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },
        alignSelf: 'start',
        color: '#2F2F2F',
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '20px'
    },
    text: {
        color: '#60666D',
        fontFamily: 'Roboto',
        fontSize: '11px',
        fontWeight: 400,
        lineHeight: '12px'
    },
    verbiageContainer: {
        '@media screen and (max-width: 450px)': {
            marginBottom: '10px',
            width: '310px'
        },
        '@media screen and (min-width: 451px) and (max-width: 1750px)': {
            marginBottom: '7px',
        },
        height: '60px',
        marginBottom: '26.6px',
        width: '400px'
    }
})
